import { LocateStoreGoBackButtonSX } from '@/components/content/Header/styles/locateStore/parts/goBackButton';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Link, Typography } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

type Props = {
	handleClick: () => void;
};

export const LocateStoreGoBackButton = ({ handleClick }: Props) => {
	const StoreLocator = useLocalization('StoreLocator');
	return (
		<Link
			display="flex"
			alignItems="center"
			sx={LocateStoreGoBackButtonSX.link}
			onClick={handleClick}
		>
			<DynamicIcon name={MATERIAL_SYMBOL_ICONS.keyboardArrowLeft} />
			<Typography component={'span'}>{StoreLocator.goBackStore.t()}</Typography>
		</Link>
	);
};
